import { render, staticRenderFns } from "./SpeakerCard.vue?vue&type=template&id=faf6b9f8&scoped=true"
import script from "./SpeakerCard.vue?vue&type=script&lang=js"
export * from "./SpeakerCard.vue?vue&type=script&lang=js"
import style0 from "./SpeakerCard.vue?vue&type=style&index=0&id=faf6b9f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf6b9f8",
  null
  
)

export default component.exports